module.exports = __webpack_public_path__ + "media/click.7f22bf65.mp3";